<template>
  <div>
    <div v-if="value.has_child && value.has_child.length">
      <p class="font-weight-bold mb-1">次級選項設定</p>
      <div
        v-for="(subOption, subOptionIndex) in value.answer_setting_items"
        :key="subOptionIndex"
      >
        <WsInfo
          type="text"
          :value="$_setText(subOption, 'subOption')"
        />
      </div>
    </div>
    <div v-else>
      <p class="font-weight-bold mb-1">選項設定</p>
      <WsInfo
        type="text"
        :value="$_setText(value)"
        class="mt-1"
      />
    </div>
  </div>
</template>

<script>
import H_optionItem from '@/helpers/optionItem';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  methods: {
    $_setText(rawData, type) {
      const isShowOptionName = false;
      const isSubOption = type === 'subOption';
      return H_optionItem.setDisplayText(rawData,isShowOptionName,isSubOption);
    }
  }
}
</script>